export function getByPath(obj, path) {
    let cur = obj;
    for (const key of parsePath(path)) {
        if (cur === null || cur === undefined)
            return undefined;
        cur = cur[key];
    }
    return cur;
}
export function setByPath(obj, path, value) {
    const keys = parsePath(path);
    function set(current, index) {
        if (index === keys.length)
            return value;
        const key = keys[index];
        const cur = current;
        const next = set(cur?.[key], index + 1);
        if (Array.isArray(current)) {
            const copy = [...current];
            copy[key] = next;
            return copy;
        }
        return { ...cur, [key]: next };
    }
    return set(obj, 0);
}
// Parse paths like "props.children[0].props.children"
// into segments like ["props", "children", 0, "props", "children"]
function parsePath(path) {
    return path
        .replace(/\[(\d+)]/g, '.$1') // [0] → .0
        .split('.')
        .filter(s => s !== '')
        .map(s => (/^\d+$/.test(s) ? Number(s) : s));
}
